/**
 * Represents padding values for left, top, right and bottom with default or specified measurements.
 *
 * @private
 */
var _PdfPaddings = /** @class */ (function () {
    function _PdfPaddings(left, top, right, bottom) {
        /**
         * Specifies the left padding value.
         *
         * @private
         */
        this._left = 0;
        /**
         * Specifies the right padding value.
         *
         * @private
         */
        this._right = 0;
        /**
         * Specifies the top padding value.
         *
         * @private
         */
        this._top = 0;
        /**
         * Specifies the bottom padding value.
         *
         * @private
         */
        this._bottom = 0;
        if (typeof left === 'undefined') {
            this._left = 0.5;
            this._right = 0.5;
            this._top = 0.5;
            this._bottom = 0.5;
        }
        else {
            this._left = left;
            this._right = right;
            this._top = top;
            this._bottom = bottom;
        }
    }
    return _PdfPaddings;
}());
export { _PdfPaddings };
